/*
 *
 * Wallets reducer
 *
 */
import produce from 'immer';
import {
  DEFAULT_ACTION,
  DISABLE_LOADER,
  ENABLE_LOADER,
  UPDATE_BANK_DETAILS,
  UPDATE_DISPUTE_WALLET_BANK_DETAILS,
  UPDATE_DISPUTE_WALLET_STATUS,
  UPDATE_FEE_WALLET_DETAILS,
  UPDATE_WALLET_BALANCE,
  UPDATE_WALLET_STATUS,
} from './constants';

export const initialState = {
  isLoading: false,
  walletsData: {},
  walletBalance: {},
  bankDetails: {},
  feeWallet: {},
  disputeWallet: {},
  disputeWalletBankDetails: {},
};

/* eslint-disable default-case, no-param-reassign */
const walletsReducer = (
  state = initialState,
  action: { type: string; data: any },
) =>
  produce(state, draft => {
    switch (action.type) {
      case ENABLE_LOADER:
        draft.isLoading = true;
        break;
      case DISABLE_LOADER:
        draft.isLoading = false;
        break;
      case UPDATE_WALLET_STATUS:
        draft.walletsData = { ...action.data };
        break;
      case UPDATE_DISPUTE_WALLET_STATUS:
        draft.disputeWallet = { ...action.data };
        break;
      case UPDATE_WALLET_BALANCE: {
        const { walletType, ...rest } = action.data;
        draft.walletBalance = {
          ...draft.walletBalance,
          [walletType]: { ...rest },
        };
        break;
      }
      case UPDATE_BANK_DETAILS:
        draft.bankDetails = { ...action.data };
        break;
      case UPDATE_DISPUTE_WALLET_BANK_DETAILS:
        draft.disputeWalletBankDetails = { ...action.data };
        break;
      case UPDATE_FEE_WALLET_DETAILS:
        draft.feeWallet = { ...action.data };
        break;
      case DEFAULT_ACTION:
        break;
    }
  });

export default walletsReducer;
